var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreadsLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 9.08 8.3 C 12.36 5.03 16.73 7.36 16.3 12.23 C 15.88 17.11 12.86 16.95 12.33 16.95 C 7.23 16.95 7.68 11.21 13.04 11.21 C 22.66 11.21 22.08 22.37 12.11 22.37 C 8.2 22.37 3.12 20.39 3.12 11.67 C 3.12 0.5 17.05 -2.73 20.88 7.82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreadsLine);
export default __webpack_public_path__ + "static/media/threads_line.7d27530ad6176db2dc8ef9c1377df919.svg";
export { ForwardRef as ReactComponent };